module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "page-news"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('clearfix', {
    attrs: {
      "biggest": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 content fb-bg-dark"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('message.title.main.news')))])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.news.length === 0),
      expression: "news.length === 0"
    }],
    staticClass: "row"
  }, [_c('clearfix', {
    attrs: {
      "wide": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 content fb-bg-light"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('message.text.no_foobars')) + "\n      ")])], 1), _vm._v(" "), _vm._l((_vm.news), function(fb) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.news.length > 0),
        expression: "news.length > 0"
      }],
      staticClass: "row"
    }, [_c('clearfix', {
      attrs: {
        "wide": true
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 content fb-bg-light"
    }, [_c('h4', [_c('router-link', {
      attrs: {
        "to": {
          name: 'Foobar',
          params: {
            id: fb.id
          }
        }
      }
    }, [_vm._v(_vm._s(fb.title))])], 1), _vm._v(" "), _c('div', {
      staticClass: "foobar-description",
      domProps: {
        "innerHTML": _vm._s(fb.description)
      }
    })])], 1)
  }), _vm._v(" "), _c('clearfix', {
    attrs: {
      "biggest": true
    }
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5257e1dd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/foobar/FoobarNews.vue
// module id = 1832
// module chunks = 1